export default __webpack_public_path__ + "static/Luke-Gamble-Logo-Top-e5edd13e25640dddae902670d036db72.png";